export default __webpack_public_path__ + "static/media/hd5.2125b4d0.webp";